import { AfterContentChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, withLatestFrom } from 'rxjs/operators';
import { validString } from 'src/app/shared/utilities/types.utils';
import { AppState } from '../../../app.state';
import { selectAppConfig } from '../../../core/application-config/application-config.selectors';
import { selectMerchantId } from '../../../core/client-configuration/client-configuration.selectors';
import { LocaleService } from '../../../core/locale/locale.service';
import { parseFilenameForAltText } from '../../../shared/utilities/string.utils';

@Component({
	selector: 'ahp-login-layout',
	templateUrl: './login-layout.component.html',
	styleUrls: ['./login-layout.component.scss'],
})
export class LoginLayoutComponent implements OnInit, OnDestroy, AfterContentChecked {
	/**
	 * logo path built from appConfig
	 */
	public logoPath: string;
	/**
	 * logo path built from appConfig
	 */
	public logoAltTag: string;
	/**
	 * The page's heading for accessibility
	 */
	public pageHeading: string;
	/**
	 * For unsubscribing to observables when the component destroys.
	 */
	private _destroy$ = new Subject<void>();

	/**
	 * construct the component
	 * @param _store$ the local store
	 * @param _locale the locale service
	 * @param _title the title service
	 */
	constructor(private _store$: Store<AppState>, private _locale: LocaleService, private _title: Title) {}
	/**
	 * Handles initialization
	 * Checks for and sets the merchant logo if there is one
	 */
	ngOnInit(): void {
		this._store$
			.pipe(
				select(selectAppConfig(['assetsPath', 'logo'])),
				withLatestFrom(this._store$.select(selectMerchantId)),
				takeUntil(this._destroy$)
			)
			.subscribe(([appConfigs, merchantId]) => {
				const logoAltLocale = `accessibility.logoalttext_${merchantId}`;
				const { assetsPath, logo } = appConfigs;

				if (validString(assetsPath) && validString(logo)) {
					this.logoPath = assetsPath.concat(logo);
					this.logoAltTag = this._locale.has(logoAltLocale)
						? this._locale.get(logoAltLocale)
						: parseFilenameForAltText(logo);
				}
			});
	}

	/**
	 * handles changes after content is checked
	 */
	ngAfterContentChecked() {
		this.pageHeading = this._title.getTitle();
	}

	/**
	 * Handles cleanup when the component is being destroyed
	 */
	ngOnDestroy(): void {
		this._destroy$.next();
		this._destroy$.complete();
	}
}
